import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { waLink } from "@/lib/constants";

export const FloatingWhatsApp = () => (
  <motion.a
    data-testid="floating-whatsapp-button"
    href={waLink()}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Falar no WhatsApp"
    initial={{ opacity: 0, scale: 0.6 }}
    animate={{ opacity: 1, scale: 1 }}
    transition={{ delay: 2.6, duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
    className="fixed bottom-6 right-6 z-[60] group"
  >
    <span className="absolute inset-0 rounded-full bg-wa/40 animate-pulse-ring" />
    <span className="relative flex h-14 w-14 items-center justify-center rounded-full bg-wa text-ink shadow-[0_0_30px_rgba(37,211,102,0.35)] group-hover:bg-wahover transition-colors duration-300">
      <MessageCircle className="h-6 w-6" />
    </span>
  </motion.a>
);
